(function (ng) {
    ng.module('evo.Compare.Filters').filter('priceRange', ['$filter',

        function ($filter) {
            var currencyFilter = $filter('numeralCurrency');

            return function (priceRange) {
                if (!priceRange) {
                    return currencyFilter(0);
                }

                var displayText = currencyFilter(priceRange.Minimum);

                if (priceRange.IsRanged) {
                    displayText += ' - ' + currencyFilter(priceRange.Maximum);
                }

                return displayText;
            };
        }]);
})(angular);